import { FEATURED_PUBLIC_LABEL, FEATURED_PUBLIC_TOOLTIP } from "../../constants/automapFeaturedPlacementConstants";
import { useOptionalLocale } from "../../intl";

export default function FeaturedPlacementBadge({
  label,
  tooltip = FEATURED_PUBLIC_TOOLTIP,
  className = "",
}) {
  const localeContext = useOptionalLocale();
  const resolvedLabel =
    label ||
    localeContext?.t?.("automotive.card.featured") ||
    localeContext?.t?.("automotive.search.featuredTitle") ||
    FEATURED_PUBLIC_LABEL;

  return (
    <span
      className={`featured-placement-badge ${className}`.trim()}
      title={tooltip}
      aria-label={`${resolvedLabel}. ${tooltip}`}
    >
      {resolvedLabel}
    </span>
  );
}
